import { Link } from "react-router-dom";
import logo from "../../../assest/logo.svg";

const LogoHeader = () => {
  return (
    <Link to="/">
      <div className="logoHeader">
        <img src={logo} alt="logo" />
        <h1>AAYOJAN</h1>
      </div>
    </Link>
  );
};

export default LogoHeader;
